import React, { FC, useState } from 'react'

import { Box, Slider, makeStyles } from '@material-ui/core'

import { PlayerProfileResponse, MatchStatus, Match } from 'protos'
import { Optional } from 'types'

import { TimelineModeSwitch, TimelineChart, HorizontalDragBox, TimelineEvents } from './components'
import { PlayerProfileEmpty } from '../../components'

type Props = {
  profile: PlayerProfileResponse
  contentWidth: number
}

const useStyles = makeStyles(() => {
  return {
    interactiveContent: {
      backgroundImage: 'linear-gradient(to bottom, #324F6F, #1E2C3F)'
    },
  }
})

const TimelineTab: FC<Props> = ({ profile, contentWidth }) => {
  const classes = useStyles()
  const [mode, setMode] = useState<'team' | 'global'>('team')
  const [zoom, setZoom] = useState(0)

  const currentMatch = profile.currentMatch as Optional<Match>
  const globalTimeline = profile.globalTimeline as PlayerProfileResponse.TimelinePoint[]
  const teamTimeline = profile.teamTimeline as PlayerProfileResponse.TimelinePoint[]

  if (
    !currentMatch || currentMatch.status === MatchStatus.MS_UPCOMING ||
    profile.globalTimeline.length === 0 ||
    profile.teamTimeline.length === 0
  ) {
    return (
      <PlayerProfileEmpty />
    )
  }

  const primaryTimeline = mode === 'global' ? globalTimeline : teamTimeline
  const secondaryTimeline = mode === 'team' ? globalTimeline : teamTimeline
  const liveIndex = currentMatch.status === MatchStatus.MS_LIVE ? profile.liveIndex : -1

  return (
    <>
      <div className={classes.interactiveContent}>
        <HorizontalDragBox style={{ width: contentWidth }}>
          {contentWidth > 0 && (
            <TimelineChart
              zoom={zoom}
              width={contentWidth}
              liveIndex={liveIndex}
              primaryTimeline={primaryTimeline}
              secondaryTimeline={secondaryTimeline}
            />
          )}
        </HorizontalDragBox>

        <TimelineModeSwitch
          active={mode}
          onChange={setMode}
        />

        <Box mx={3}>
          <Slider
            value={100 * zoom}
            step={10}
            onChange={(ev, value) => { setZoom(value as number / 100) }}
          />
        </Box>
      </div>

      <TimelineEvents timeline={primaryTimeline} />
    </>
  )
}

export default TimelineTab
try {
    // @ts-ignore
    TimelineTab.displayName = "TimelineTab";
    // @ts-ignore
    TimelineTab.__docgenInfo = { "description": "", "displayName": "TimelineTab", "props": { "profile": { "defaultValue": null, "description": "", "name": "profile", "required": true, "type": { "name": "any" } }, "contentWidth": { "defaultValue": null, "description": "", "name": "contentWidth", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/TimelineTab.tsx#TimelineTab"] = { docgenInfo: TimelineTab.__docgenInfo, name: "TimelineTab", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/TimelineTab.tsx#TimelineTab" };
}
catch (__react_docgen_typescript_loader_error) { }